'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndEmail } from '../../Entities/Ind/IndEmail';
import { IndEmailCollection } from '../../Collections/Ind/IndEmailCollection';

export class IndEmailRepository extends CoreRepository {
  public getIndEmails(indId: number, options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getIndEmails(indId, options).then((response) => {
      const collection = new IndEmailCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new IndEmail();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public createIndEmail(indId: number, payload: any[]) {
    return this.webAPI.createIndEmail(indId, payload).then((response) => {
      const indEmail = new IndEmail();
      indEmail.hydrate(response);

      return indEmail;
    });
  }

  public removeIndEmail(indId: number, indEmailId: number) {
    return this.webAPI.removeIndEmail(indId, indEmailId).then((response) => {
      return response;
    });
  }

  public updateIndEmail(indId: number, indEmailId: number, payload: any[]) {
    return this.webAPI.updateIndEmail(indId, indEmailId, payload).then((response) => {
      return response;
    });
  }

  public moveIndEmail(individualId: number, individualEmailId: number, payload: any[]) {
    return this.webAPI.moveIndEmail(individualId, individualEmailId, payload).then((response) => {
      return response;
    });
  }
}
